/**
 * What everyone sees while the site is paused from the admin portal (site-settings.ts on the
 * server; asked for 2026-10-19, "a way to turn down the website from the admin"). The server
 * already refuses everything else; this says so kindly, with the administrator's own words.
 */
import { t } from './strings.ts';

export function PausedPage({ message }: { message?: string | null }) {
  return (
    <main className="page paused-page">
      <h1>{t('pausedTitle')}</h1>
      <p>{message || t('pausedText')}</p>
      <p className="muted small">{t('pausedCards')}</p>
    </main>
  );
}
